import { ChangeDetectorRef, ElementRef, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { isDefined } from '@fi-shared/utils';
import { FiTooltipComponent } from '@fi-shared/fi-tooltip/fi-tooltip.component';
import { FiTooltipBase } from '@fi-shared/fi-tooltip/fi-tooltip-base';

@Injectable()
export class FiValidatorTooltipService {
    constructor() {}

    showTooltipErrorMessage(args: {
        hasErrors: boolean;
        isTouched: boolean;
        showErrorBorder: boolean;
        showErrorTooltip: boolean;
        renderer: Renderer2;
        fiTooltipRef: FiTooltipBase;
        contentElement: HTMLElement;
        cdr: ChangeDetectorRef;
    }) {
        const contentEl: HTMLElement = args.contentElement;
        if (contentEl && isDefined(args.fiTooltipRef?.tooltipRef) && isDefined(args.renderer)) {
            if (args.hasErrors && args.isTouched) {
                if (args.showErrorTooltip) {
                    args.fiTooltipRef.hideTooltip();
                }

                if (args.showErrorBorder) {
                    args.renderer.addClass(contentEl, 'content-validator-has-errors');
                }
                if (args.showErrorTooltip) {
                    setTimeout(() => {
                        // update position after scroll on validation error
                        args.fiTooltipRef.showTooltip();
                        args.fiTooltipRef.updateTooltipPosition();
                    }, 1000);
                }
            } else {
                if (args.showErrorBorder) {
                    args.renderer.removeClass(contentEl, 'content-validator-has-errors');
                }
                if (args.showErrorTooltip) {
                    args.fiTooltipRef.hideTooltip();
                }
            }
        }
        args.cdr.markForCheck();
    }
}
